import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import Loader from './Loader';
import Sidebar from './Sidebar';
import { toast } from 'react-toastify';
import { firestore } from '../firebase.config';
import {
    collection,
    getDocs,
    deleteDoc,
    doc,
    addDoc,
    updateDoc, // 🆕
} from 'firebase/firestore';
import { Trash2, Edit2 } from 'lucide-react'; // 🆕 Edit2

const DonationInKind = () => {
    const [heading, setHeading] = useState('');
    const [description, setDescription] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [fieldAlert, setFieldAlert] = useState(false);
    const [alertStatus, setAlertStatus] = useState('danger');
    const [msg, setMsg] = useState(null);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [donationList, setDonationList] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});
    const [editId, setEditId] = useState(null); // 🆕 Track which item is being edited
const formRef = useRef(null);

    const cloudName = "dabhatz7m";
    const uploadPreset = "ImageUpload";

    const [uploadedImageUrl, setUploadedImageUrl] = useState('');
    const [uploadProgress, setUploadProgress] = useState(0);

    const toggleSidebar = (state) => {
        setIsSidebarOpen(state);
    };

    const toggleReadMore = (id) => {
        setExpandedRows((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const handleImageUpload = (e) => {
        e.preventDefault();
        const file = document.getElementById("kindImageInput").files[0];
        if (!file) return alert("Please select an image!");

        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", uploadPreset);
        formData.append('folder', 'DonationInKind');

        const xhr = new XMLHttpRequest();
        xhr.open("POST", `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, true);

        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
                const percentComplete = (event.loaded / event.total) * 100;
                setUploadProgress(percentComplete);
            }
        };

        xhr.onload = () => {
            if (xhr.status === 200) {
                const data = JSON.parse(xhr.responseText);
                if (!data.secure_url) {
                    console.error("Secure URL is missing from Cloudinary response");
                    return;
                }
                setUploadedImageUrl(data.secure_url);
                setUploadProgress(0);
            } else {
                console.error("Failed to upload image to Cloudinary");
                setUploadProgress(0);
            }
        };

        xhr.onerror = () => {
            console.error("Error uploading image:", xhr.statusText);
            setUploadProgress(0);
        };

        xhr.send(formData);
    };

    const saveDonationInKind = async () => {
        setIsLoading(true);

        if (!heading || !description) {
            setFieldAlert(true);
            setMsg("Required fields can't be empty");
            setAlertStatus("danger");
            toast.error("Required fields can't be empty");
            setTimeout(() => {
                setFieldAlert(false);
                setIsLoading(false);
            }, 4000);
            return;
        }

        if (!uploadedImageUrl) {
            setFieldAlert(true);
            setMsg("Please upload an image.");
            setAlertStatus("danger");
            toast.error("Please upload an image.");
            setIsLoading(false);
            setTimeout(() => setFieldAlert(false), 4000);
            return;
        }

        try {
            if (editId) {
                // 🆕 Update existing item
                await updateDoc(doc(firestore, 'DonationInKind', editId), {
                    heading,
                    description,
                    imageUrl: uploadedImageUrl,
                });
                setIsLoading(false);
                setFieldAlert(true);
                setMsg("Donation In Kind updated successfully");
                setAlertStatus("success");
                toast.success("Donation In Kind updated successfully");
            } else {
                // Save new item
                const id = `${Date.now()}`;
                const data = {
                    id,
                    heading,
                    description,
                    imageUrl: uploadedImageUrl,
                };
                await addDoc(collection(firestore, 'DonationInKind'), data);
                setIsLoading(false);
                setFieldAlert(true);
                setMsg("Donation In Kind saved successfully");
                setAlertStatus("success");
                toast.success("Donation In Kind saved successfully");
            }

            clearData();
            fetchDonations();
            setTimeout(() => setFieldAlert(false), 4000);
        } catch (error) {
            console.error("Error saving donation:", error);
            toast.error("Failed to save");
            setIsLoading(false);
        }
    };

    const clearData = () => {
        setHeading('');
        setDescription('');
        setUploadedImageUrl('');
        setEditId(null); // 🆕 Reset edit state
    };

    const fetchDonations = async () => {
        try {
            const querySnapshot = await getDocs(collection(firestore, 'DonationInKind'));
            const donations = [];
            querySnapshot.forEach((docSnap) => {
                donations.push({ ...docSnap.data(), docId: docSnap.id });
            });
            setDonationList(donations);
        } catch (error) {
            console.error("Error fetching donations:", error);
        }
    };

    const handleDelete = async (docId) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this item? This action cannot be undone.");
        if (!confirmDelete) return;

        try {
            await deleteDoc(doc(firestore, 'DonationInKind', docId));
            toast.success("Deleted successfully");
            fetchDonations();
        } catch (error) {
            console.error("Error deleting donation:", error);
            toast.error("Failed to delete");
        }
    };

    // 🆕 Populate form with existing item data for editing
    const handleEditDonation = (item) => {
        setHeading(item.heading);
        setDescription(item.description);
        setUploadedImageUrl(item.imageUrl || '');
        setEditId(item.docId);
        if (formRef.current) {
        formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    };

    useEffect(() => {
        fetchDonations();
    }, []);

    return (
        <div className='lg:flex h-screen bg-white'>
            <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
            <div className={`flex-1 p-1 lg:p-12 overflow-y-auto transition-all duration-300 lg:mt-2 mt-16 ${isSidebarOpen ? 'ml-56 p-0' : 'lg:ml-20 sm:ml-2'}`}>

                {/* Form Card */}
                <div ref={formRef} className={`w-full max-w-4xl mx-auto bg-white shadow-xl rounded-2xl lg:p-8 ${isSidebarOpen ? 'p-1' : 'lg:p-8 p-8'}`}>
                    {/* 🆕 Dynamic heading */}
                    <h1 className={`lg:text-2xl font-bold text-[#fcaf17] mb-6 ${isSidebarOpen ? 'text-[13px]' : ''}`}>
                        {editId ? "Edit Donation In Kind" : "Donation In Kind"}
                    </h1>

                    {fieldAlert && (
                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            className={`p-3 rounded-lg text-center text-lg font-medium mb-4 ${alertStatus === "danger" ? "bg-red-100 text-red-600" : "bg-green-100 text-green-600"}`}
                        >
                            {msg}
                        </motion.p>
                    )}

                    <div className='lg:space-y-4 space-y-2'>

                        {/* Image Upload */}
                        <div>
                            <label className={`block text-gray-700 text-sm font-medium mb-2 ${isSidebarOpen ? 'text-xs' : ''}`}>
                                Image
                            </label>
                            <label
                                htmlFor="kindImageInput"
                                className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 cursor-pointer"
                            >
                                <svg
                                    className="mr-2 h-5 w-5 text-[#fcaf17]"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                                <span>Upload Image</span>
                            </label>
                            <input
                                type="file"
                                id="kindImageInput"
                                accept="image/*"
                                onChange={handleImageUpload}
                                className="hidden"
                            />

                            {/* Progress Bar */}
                            {uploadProgress > 0 && (
                                <div className="mt-2">
                                    <div className="bg-gray-200 rounded-full h-2.5 mb-1 dark:bg-gray-700">
                                        <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: `${uploadProgress}%` }}></div>
                                    </div>
                                    <p className="text-sm text-gray-600 text-center">{Math.round(uploadProgress)}%</p>
                                </div>
                            )}

                            {/* Preview */}
                            {uploadedImageUrl && (
                                <div className="relative mt-3 w-[200px] h-[130px] border rounded-md overflow-hidden">
                                    <img
                                        src={uploadedImageUrl}
                                        alt="Uploaded"
                                        className="w-full h-full object-cover"
                                    />
                                    <button
                                        onClick={() => setUploadedImageUrl('')}
                                        className="absolute top-1 right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs hover:bg-red-600"
                                        title="Remove image"
                                    >
                                        ✕
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* Heading */}
                        <div>
                            <label className={`block text-gray-700 text-sm font-medium mb-2 ${isSidebarOpen ? 'text-xs' : ''}`}>
                                Heading
                            </label>
                            <input
                                type='text'
                                value={heading}
                                autoComplete='off'
                                placeholder='Enter Heading'
                                onChange={(e) => setHeading(e.target.value)}
                                className={`w-full px-4 py-2 border border-gray-300 lg:text-md text-sm rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-500 focus:outline-none ${isSidebarOpen ? 'text-xs' : ''}`}
                            />
                        </div>

                        {/* Description */}
                        <div>
                            <label className={`block text-gray-700 text-sm font-medium mb-2 ${isSidebarOpen ? 'text-xs' : ''}`}>
                                Description
                            </label>
                            <textarea
                                value={description}
                                autoComplete='off'
                                placeholder='Enter Description'
                                onChange={(e) => setDescription(e.target.value)}
                                rows={4}
                                className={`w-full px-4 py-2 border border-gray-300 lg:text-md text-sm rounded-lg text-gray-800 focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none ${isSidebarOpen ? 'text-xs' : ''}`}
                            />
                        </div>

                        {/* 🆕 Save / Update + Cancel Buttons */}
                        <div className="flex justify-start pt-2 gap-3">
                            <button
                                className="bg-blue-600 text-white lg:text-sm text-xs py-2 px-4 rounded-lg hover:bg-blue-700 transition duration-300"
                                onClick={saveDonationInKind}
                            >
                                {isLoading ? <Loader /> : editId ? 'Update' : 'Save'}
                            </button>
                            {editId && (
                                <button
                                    className="bg-gray-200 text-gray-700 lg:text-sm text-xs py-2 px-4 rounded-lg hover:bg-gray-300 transition duration-300"
                                    onClick={clearData}
                                >
                                    Cancel
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {/* Table Section */}
                {donationList.length > 0 ? (
                    <div className="mt-12 p-8 transform transition-all duration-300 hover:shadow-yellow-300/40">
                        <h2 className="text-3xl font-extrabold mb-8 text-[#fcaf17] tracking-wide flex items-center gap-3 animate-fade-in-down">
                            <span>✨</span> Donation In Kind Collection
                        </h2>

                        <div className="overflow-x-auto overflow-hidden border border-yellow-200 transform transition-all duration-300 hover:shadow-yellow-200/20">
                            <table className="min-w-full text-sm text-left text-gray-700">
                                <thead className="bg-gradient-to-r from-yellow-100 to-yellow-200/70 backdrop-blur-sm border-b border-yellow-300 text-[14px] uppercase font-bold tracking-wider text-orange-800 animate-slide-in-top">
                                    <tr>
                                        <th className="px-6 py-4">Sl. No.</th>
                                        <th className="px-6 py-4">Image</th>
                                        <th className="px-6 py-4">Heading</th>
                                        <th className="px-6 py-4">Description</th>
                                        <th className="px-6 py-4 text-center">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {donationList.map((item, index) => (
                                        <tr
                                            key={item.docId}
                                            className="group bg-white/70 transition-all duration-300 hover:bg-orange-50/70 border-b border-orange-100 last:border-b-0 animate-fade-in"
                                        >
                                            <td className="px-6 py-4 font-semibold text-gray-800 text-base">{index + 1}</td>
                                            <td className="px-6 py-4">
                                                <img
                                                    src={item.imageUrl}
                                                    alt={item.heading}
                                                    className="w-28 h-20 object-cover rounded-xl border-2 border-gray-200 shadow-md group-hover:scale-105 group-hover:border-orange-400 transition-all duration-300 ease-in-out cursor-pointer"
                                                />
                                            </td>
                                            <td className="px-6 py-4 text-gray-900 font-medium">{item.heading}</td>
                                            <td className="px-6 py-4 text-gray-600 text-sm leading-relaxed max-w-xs">
                                                <p className={`${expandedRows[item.docId] ? '' : 'line-clamp-3'}`}>
                                                    {item.description}
                                                </p>
                                                {item.description?.length > 100 && (
                                                    <button
                                                        onClick={() => toggleReadMore(item.docId)}
                                                        className="text-blue-600 text-xs font-semibold mt-1 hover:underline"
                                                    >
                                                        {expandedRows[item.docId] ? 'Less' : 'More'}
                                                    </button>
                                                )}
                                            </td>
                                            {/* 🆕 Actions with Edit + Remove */}
                                            <td className="px-6 py-4 text-center">
                                                <div className="flex justify-center gap-2">
                                                    <button
                                                        onClick={() => handleEditDonation(item)}
                                                        className="inline-flex items-center gap-2 text-blue-600 hover:text-white bg-blue-100 hover:bg-blue-500 px-4 py-2 rounded-full text-sm font-semibold shadow-md transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-2"
                                                        title="Edit Item"
                                                    >
                                                        <Edit2 className="w-4 h-4" />
                                                        Edit
                                                    </button>
                                                    <button
                                                        onClick={() => handleDelete(item.docId)}
                                                        className="inline-flex items-center gap-2 text-red-600 hover:text-white bg-red-100 hover:bg-red-500 px-4 py-2 rounded-full text-sm font-semibold shadow-md transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-300 focus:ring-offset-2"
                                                        title="Remove Item"
                                                    >
                                                        <Trash2 className="w-4 h-4" />
                                                        Remove
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : (
                    <div className="mt-12 p-8 text-center text-gray-500 text-lg italic bg-white border border-orange-100 rounded-xl shadow-sm">
                        No Donation In Kind entries yet. Let's add one!
                    </div>
                )}

                <style jsx>{`
                    @keyframes fade-in-down {
                        from { opacity: 0; transform: translateY(-20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    @keyframes slide-in-top {
                        from { opacity: 0; transform: translateY(-10px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    @keyframes fade-in {
                        from { opacity: 0; }
                        to { opacity: 1; }
                    }
                    .animate-fade-in-down { animation: fade-in-down 0.8s ease-out forwards; }
                    .animate-slide-in-top { animation: slide-in-top 0.6s ease-out forwards; }
                    .animate-fade-in { animation: fade-in 0.5s ease-out forwards; }
                `}</style>
            </div>
        </div>
    );
};

export default DonationInKind;